import { currency } from "../types/index.const";

const currencyOptions = currency.map((el) => ({
  label: el,
  value: el,
}));

export default currencyOptions;
